export default __webpack_public_path__ + "static/media/BSC.3235b263.svg";